/**
 * @template V - Option value type, i.e. the literal key by which to sort
 */
export interface FilterOption<V> {
  value: V;
  text: string;
}

export type HistoryPanelFilterOptionsValue = 'all-activity' | 'with-updates-only';
export const HistoryPanelFilterOptions: FilterOption<HistoryPanelFilterOptionsValue>[] = [
  {
    value: 'all-activity',
    text: 'All Activity',
  },
  {
    value: 'with-updates-only',
    text: 'Only activity with situational updates',
  },
];
